import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { fetchLegalFooter } from './LegalFooterSlice';
import { LegalFooterContentSelector } from './LegalFooterContentSelector';
import { LegalFooter } from 'cpnl-common';

export function useLegalFooter(): AbstractContentState<LegalFooter> {
    return useCmsContent(fetchLegalFooter, LegalFooterContentSelector);
}
